import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const testimonials = [
    {
      text: "Siantek is a distributor for factory automation equipment. Outstanding payments are common in our business. We contacted PayAssured to help track and recover our outstanding amount. Eventually we signed up for their business protection plan. I have made one claim on the business protection plan and it helped me recover 100% of my payment in about 3.5 - 4 months.",
      company: "Siantek",
      logo: "/images/testimonials/sian-tek.png"
    },
    {
      text: "I had about 1 crore outstanding every year. With 100's of clients, I did not even know who had paid us back and who hadn't. PayAssured systems spotlighted pending payments and enabled tracking payments. Their business protection plan offers us up to 50 lakhs cover. That way I know I am at least getting 50 lakhs back this year out of 1 Crore outstanding. Thats half a peace of mind for me.",
      company: "Stanofic",
      logo: "/images/testimonials/stanofic.png"
    },
    {
      text: "We are into office supplies with 2 Crore outstanding per year. I bought payassured's business protection for Foxdart this year. This month alone, its helped me claim back 2 lakhs in outstanding due from a non-paying customer. Its been about 7 months.",
      company: "Foxdart",
      logo: "/images/testimonials/foxdart.png"
    },
    {
      text: "Optimize my data is a marketing agency and cloud consultancy. We provide IT help to cutomers. After buying payassured business protection, I don't hesitate signing up newer customers. Because I am guarenteed payments from payassured team, if the customer does not pay. I have made 2 claims so far and both have been settled in time.",
      company: "Optimize My Data",
      logo: "/images/testimonials/optimize-my-data.png"
    }
  ];

  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="quote-icon">❝</div>
            <p className="testimonial-text">{testimonial.text}</p>
            <div className="testimonial-company">
              <img 
                src={testimonial.logo} 
                alt={`${testimonial.company} logo`} 
                className="company-logo"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials; 